// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"b92d3464","920":"f36a3507"}[chunkId] + ".chunk.css";
};